<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <div class="container-fluid main-component">
    <div class="row justify-content-center mt-5">
      <div  class="col-sm-12 col-md-8 col-lg-8 col-xl-4">
        <b-card
          class="slide-in-fwd-tl"

          style="
            padding: 1%;
            width: 100%;
            border-radius: 20px;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
          "
        >
          <p
            style="
              text-align: left;
              color: #093974;
              font-size: 18px;
              font-weight: 600;
            "
          >
            Información de la queja
          </p>
          <b-table-simple style="margin-top: 7%">
            <tr>
              <td style="font-size: 15px"><label>ID Paciente</label></td>
              <td style="font-size: 15px">{{ datos.idPaciente}}</td>
            </tr>
            <tr>
              <td style="font-size: 15px">
                <label>Nombre del Paciente</label>
              </td>
              <td style="font-size: 15px">{{ datos.paciente }}</td>
            </tr>
            <tr>
              <td style="font-size: 15px">
                <label>Folio</label>
              </td>
              <td style="font-size: 15px">{{ idTicket }}</td>
            </tr>
          </b-table-simple>
          <div style="margin-top: 10%">
            <p>
              A través de <strong>{{  }}</strong> el paciente
              comenta:
            </p>
            <p v-if="datos.comentarios.length < 160">
              <strong>{{ datos.comentarios }}</strong>
            </p>
            <b-button v-else 
              >Ver comentarios</b-button
            >
          </div>
        </b-card>
        <div>
        </div>
      </div>

      <div  class="mtpClass">
     
      </div>
    </div>
  </div>
</div>


<!--   <b-card
      class="mb-3"
      style="
                padding: 1%;
                width: 100%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
  >
    <b-table-simple>
      <tr>
        <td style="font-size: 15px">
          <label>ID Paciente: </label> {{ datos.idPaciente }}
        </td>
        <td style="font-size: 15px">
          <label>Nombre del Paciente</label> {{ datos.paciente }}
        </td>
      </tr>
      <tr>
        <td style="font-size: 15px">
          <label>Folio</label> {{ idTicket }}
        </td>
        <td style="font-size: 15px">
          <label>Categoria</label> UNICO
        </td>
      </tr>
    </b-table-simple>
    <div class="text-left d-flex">
      <p class="mr-3">
        Motivo:
      </p>
      <p>
        <strong>{{ datos.comentarios }}</strong>
      </p>
    </div>
  </b-card> -->
</template>

<script>
import {GarantiaService} from "@/apiServices/garantias/GarantiaService";

export default {
  name: "InformacionQueja",
  props:{
    idTicket: null
  },
  data(){
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      garantiaServicio: new GarantiaService(),
      datos: {
        origen: "",
        comentarios: "",
        idPaciente: "",
        paciente: "",
        driver: "",
        tema: "",
        subtema: "",
      },
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerInformacionTicket()
  },
  methods:{
    obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
      });
    },
  },
  watch:{
    idTicket(){
      this.obtenerInformacionTicket()
    }
  }
}
</script>

<style scoped>

</style>